import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message, confirmText, cancelText, variant = 'default' }) => {
  if (!isOpen) return null;

  const getIconConfig = () => {
    switch (variant) {
      case 'danger':
        return { name: 'AlertTriangle', color: 'var(--color-error)' };
      case 'success':
        return { name: 'CheckCircle', color: 'var(--color-success)' };
      case 'warning':
        return { name: 'AlertCircle', color: 'var(--color-warning)' };
      default:
        return { name: 'Info', color: 'var(--color-primary)' };
    }
  };

  const iconConfig = getIconConfig();

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-foreground/50 backdrop-blur-sm animate-fade-in">
      <div className="bg-card border border-border rounded-lg shadow-elevation-lg max-w-md w-full animate-scale-in">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className={`flex items-center justify-center w-12 h-12 rounded-full ${
              variant === 'danger' ? 'bg-error/10' :
              variant === 'success' ? 'bg-success/10' :
              variant === 'warning'? 'bg-warning/10' : 'bg-primary/10'
            }`}>
              <Icon name={iconConfig?.name} size={24} color={iconConfig?.color} />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-heading font-semibold text-foreground mb-2">{title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{message}</p>
            </div>
          </div>

          <div className="flex items-center justify-end gap-3 pt-4 border-t border-border">
            <Button
              variant="outline"
              size="default"
              onClick={onClose}
            >
              {cancelText || 'Cancel'}
            </Button>
            <Button
              variant={variant === 'danger' ? 'destructive' : 'default'}
              size="default"
              onClick={onConfirm}
              className={variant === 'success' ? 'bg-success hover:bg-success/90 text-success-foreground' : ''}
            >
              {confirmText || 'Confirm'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;